/** The capture track describes the input actually reported by the browser, not a saved preference. */
export const readActiveMicrophone = (track: MediaStreamTrack | null | undefined) => {
  if (!track || track.readyState === 'ended') return null;
  return { deviceId: track.getSettings?.().deviceId ?? '', label: track.label ?? '' };
};

/** Safari can acknowledge a device request while retaining the previous capture input. */
export const microphoneSwitchConfirmed = (
  track: MediaStreamTrack | null | undefined,
  requestedId: string
) => {
  const actual = readActiveMicrophone(track);
  return Boolean(
    actual?.deviceId && (requestedId === 'default' || actual.deviceId === requestedId)
  );
};
